import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transaction-log',
  templateUrl: './transaction-log.component.html',
  styleUrls: ['./transaction-log.component.scss']
})
export class TransactionLogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
